
<template>
  <div id="page-user-view">
    <div id="user-data" >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card  class="mb-base">
            <div class="vx-row">
              <div class="vx-col" id="avatar-col">
                <div class="img-container mb-4">
                  <img :src="photoURL" class="rounded w-full" />
                </div>
              </div>
              <div class="vx-col flex-1" id="account-info-col-1">
                <table>
                  <tr>
                    <td class="font-semibold">Name:</td>
                    <td>{{ getUserInfo.name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Email:</td>
                    <td>{{ getUserInfo.email }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">프로젝트 :</td>
                    <td>{{ activeWorkspace.title }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="팀 업무 기여도">
            <div slot="no-body">
              <div class="vx-row text-center">
                  <!-- Open Tickets Heading -->
                  <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                      <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                          <h1 class="font-bold text-5xl">{{ teamTask.allTask }}개</h1>
                          <small>팀 전체 완료 업무</small>
                      </div>
                  </div>
                  <!-- Chart -->
                  <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                      <vue-apex-charts v-if="taskAnalyticsData"  type=radialBar height=385 :options="taskAnalyticsData.chartOptions" :series="teamTask.series" />
                  </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="개인 업무 현황">
              <div slot="no-body">
                  <div class="vx-row text-center">
                      <!-- Open Tickets Heading -->
                      <!-- <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                          <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                              <h1 class="font-bold text-5xl">{{ teamTask.allTask }}개</h1>
                              <small>전체 완료 업무</small>
                          </div>
                      </div> -->
                      <!-- Chart -->
                      <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                          <vue-apex-charts v-if="userTasks.length && taskPieChart" type="pie" height="350" :options="taskPieChart.chartOptions" :series="taskPieChart.series"></vue-apex-charts>
                      </div>
                  </div>
                  <!-- Support Tracker Meta Data -->
                  <div class="flex flex-row justify-between px-8 pb-4 mt-2">
                      <p class="text-center" v-for="(val, key) in teamTask.meta" :key="key">
                        <span class="block">{{ key }}</span>
                        <span class="text-2xl font-semibold">{{ val }}개</span>
                      </p>
                  </div>
              </div>
          </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="팀 산출물 기여도">
          <div slot="no-body">
            <div class="vx-row text-center">
                <!-- Open Tickets Heading -->
              <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                  <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                      <h6 class="font-bold text-5xl">{{ teamBlog.all.ea }}</h6>
                      <small>팀 전체 산출물량</small>
                      <h6 class="font-bold text-5xl">{{ teamBlog.all.byte }}</h6>
                      <small>팀 전체 산출수</small>
                  </div>
              </div>
              <!-- Chart -->
              <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                  <vue-apex-charts v-if="blogAnalyticsData" type=radialBar height=385 :options="blogAnalyticsData.chartOptions" :series="teamBlog.series" />
              </div>
            </div>
            <div class="flex flex-row justify-between px-8 pb-4 mt-2">
                <p class="text-center">
                  <span class="block">산출물 수</span>
                  <span class="text-2xl font-semibold">{{teamBlog.user.ea}}개</span>
                </p>
                <p class="text-center">
                  <span class="block">산출물 량</span>
                  <span class="text-2xl font-semibold">{{teamBlog.user.byte}}바이트</span>
                </p>
            </div>
          </div>
        </vx-card>
        <!-- <vx-card title="차주별 개인 완료 업무">
          <span v-if="!taskCount.done">완료 업무가 없습니다</span>
          <vue-apex-charts v-if="taskCount.done" type="bar" height="350" :options="taskBarChart.chartOptions" :series="taskBarChart.series"></vue-apex-charts>
        </vx-card> -->
      </div>
        <!--
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="과제 현황" class="mb-base">
            <span v-if="submitVal.labels.length == 0">과제 결과가 없습니다</span>
            <vue-apex-charts autoresize type="donut" height="350" :options="submitPieChart.chartOptions" :series="submitPieChart.series"></vue-apex-charts>
          </vx-card>
        </div> -->
      </div>
      <vx-card title="차주별 개인 완료 업무">
        <span v-if="!taskCount.done">완료 업무가 없습니다</span>
        <vue-apex-charts v-if="taskCount.done && taskBarChart" type="bar" height="350" :options="taskBarChart.chartOptions" :series="taskBarChart.series"></vue-apex-charts>
      </vx-card>
      <!-- <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="업무 기여도" class="mb-base">
            <span v-if="!doneTasks">완료 업무가 없습니다</span>
            <vue-apex-charts v-if="allTaskPieChart && doneTasks" type="pie" height="350" :options="allTaskPieChart.chartOptions" :series="allTaskPieChart.series"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="산출물 기여도" class="mb-base">
            <span v-if="!doneTasks">산출물이 없습니다</span>
            <vue-apex-charts v-if="blogPieChart" type="pie" height="350" :options="blogPieChart.chartOptions" :series="blogPieChart.series"></vue-apex-charts>
          </vx-card>
        </div>
      </div> -->

      <!-- Permissions -->
      <!-- <vx-card> -->
        <!-- <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="ClipboardIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">출결 정보</span>
            </div>
            <vs-divider  v-if="columnDefs.length == 0"/>
          </div>
        </div>
        <div class="block overflow-x-auto">
          <span v-if="columnDefs.length == 0">출결 정보가 없습니다.</span>
        </div> -->
      <!-- </vx-card> -->
      <!-- <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="insightVector"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue> -->
    </div>
  </div>
</template>

<script>
// import ECharts from 'vue-echarts/components/ECharts'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/legend'
// import 'echarts/lib/chart/pie'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import VueApexCharts from 'vue-apexcharts'
// import analyticsData from './analyticsData.js'
// import AttendAllStatus from "./cell-renderer/AttendAllStatus.vue"
// import apexChatData from './apexChartData.js'


export default {
    name: 'AttendUser',
    components: {
      AgGridVue,
      VueApexCharts,
      // AttendAllStatus,
    },
    data() {
      return {
        user_data: null,
        user_not_found: false,
        themeColors: ['#28C76F','#FF9F43','#7367F0','#1E1E1E','#EA5455'],
        themeColors2: ['#7367F0','#28C76F', '#EA5455', '#FF9F43','#1E1E1E'],
        taskPieChart:null,
        blogPieChart:null,
        taskCount: {todo:0,inpro:0,done:0},
        allTaskPieChart:null,
        submitPieChart:null,
        taskChat:null,
        taskBarChart:null,
        columnDefs:[],
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        gridApi: null,
        userData:[],
        gridOptions: {},
        components: {
          // AttendAllStatus
        },
        submitVal: {labels:[], series:[]},
        photoURL:'',
        teamTask:{
          allTask:0,
          meta:{
          "준비 업무":0,
          "진행 업무":0,
          "완료 업무":0,
          },
          series: [0]
        },
        teamBlog:{
          all:{ea:0, byte:0},
          user:{ea:0, byte:0},
          series: [0]
        },
        taskAnalyticsData: null,
        blogAnalyticsData: null,
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      activeWorkspace() {
        return this.$store.state.space.ActiveSpaceInfo
      },
      paginationPageSize() {
        return 1
      },
      attends(){
        return this.$store.state.insight.attends
      },
      getUserInfo(){
        return this.$store.getters['task/getProjectMembers'](this.$route.params.userId)
      },
      // getUserInfo(){
      //   return this.$store.getters['space/getMemberInfo'](this.$route.params.userId)
      // },
      testResults(){
        return this.$store.state.insight.testResults
      },
      insightVector(){
        return this.$store.state.insight.insightVector
      },
      userTasks(){
        return this.$store.state.task.userTasks
      },
      doneTasks(){
        return this.$store.state.task.doneTasks
      },
      currentPage: {
        get() {
          if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      },
    },
    mounted () {
      this.gridApi = this.gridOptions.api
    },
    methods: {

    },
    beforeDestroy() {
      // this.$store.unregisterModule('insight')
      // moduleInsight.isRegistered = false
    },
    created() {
      if(this.getUserInfo){
        this.photoURL = require("@/assets/images/portrait/small/"+ this.getUserInfo.photo_url)
      }
      this.$store.dispatch('task/getUserTask', 'project_id='+this.$route.params.projectId+'&user_id='+this.$route.params.userId).then(()=>{
        var taskBar ={data:[], categories:[]}
        for (var i in this.userTasks){
          if(this.userTasks[i].state == 1){
            this.taskCount.todo++
          }else if(this.userTasks[i].state == 2){
            this.taskCount.inpro++
          }else{
            this.taskCount.done++
            // find((blog) => blog.id == id),
            var index = taskBar.categories.findIndex((categorie)=> categorie == this.userTasks[i].weeks)
            if(index == -1){
              if(this.userTasks[i].weeks == null){
                taskBar.categories.push("기간 없음")
              }
              else{
                taskBar.categories.push(this.userTasks[i].weeks)
              }
              taskBar.data.push(1)
            }else{
              taskBar.data[index]++
            }
          }
        }
        var series = [this.taskCount.todo, this.taskCount.inpro, this.taskCount.done]
        this.taskPieChart = {series:series, chartOptions: { labels: ['할일', '진행', '완료'],  colors: this.themeColors, responsive: [{breakpoint: 480, options: { chart: { width: 150}, legend: {position: 'bottom'}}}]}}
        this.taskBarChart = {series: [{ data:taskBar.data }], chartOptions: { colors: this.themeColors2, plotOptions: { bar: { horizontal: true,}}, xaxis: {categories: taskBar.categories}}}
        var series2 = []
        this.teamTask.meta['준비 업무'] = this.taskCount.todo
        this.teamTask.meta['진행 업무'] = this.taskCount.inpro
        this.teamTask.meta['완료 업무'] = this.taskCount.done
        if(this.doneTasks){
          var value = (this.taskCount.done / this.doneTasks.length) * 100
          this.teamTask.allTask = this.doneTasks.length
          this.teamTask.series[0] = value.toFixed(0) // 소숫점 표시
          series2 = [this.taskCount.done, this.doneTasks.length-this.taskCount.done]
        }else{
          this.teamTask.allTask = 0
          this.teamTask.series[0] = 0
          series2 = [0, 0]
        }
        this.allTaskPieChart = {series:series2, chartOptions: { labels: ['내업무', '다른업무'],  colors: this.themeColors, responsive: [{breakpoint: 480, options: { chart: { width: 150}, legend: {position: 'bottom'}}}]}}
      })

      // var payload = 'project_id='+this.$route.params.projectId+'&user_id='+this.$route.params.userId
      this.$store.dispatch('projectBlog/getUserBlog', 'project_id='+this.$route.params.projectId+'&user_id='+this.$route.params.userId).then((resolve)=>{
        var value = (resolve.user / (resolve.user+resolve.other)) * 100
        this.teamBlog.all.byte = resolve.user+resolve.other
        this.teamBlog.all.ea = resolve.blog_count
        this.teamBlog.series[0] = value.toFixed(0) // 소숫점 표시
        this.teamBlog.user.ea = resolve.user_count
        this.teamBlog.user.byte = resolve.user
        // var series = [resolve.user, resolve.other]
        // this.blogPieChart = {series:series, chartOptions: { labels: ['내산출물', '다른산출물'],  colors: this.themeColors2, responsive: [{breakpoint: 480, options: { chart: { width: 150}, legend: {position: 'bottom'}}}]}}
        // console.log(this.$store.state.projectBlog.userBlogs)
      })
      this.taskAnalyticsData = {
        chartOptions: {
            plotOptions: {
                radialBar: {
                    size: 158,
                    offsetY: -30,
                    startAngle: -150,
                    endAngle: 150,
                    hollow: {
                        size: '65%',
                    },
                    track: {
                        background: "rgba(0,0,0,0)",
                        strokeWidth: '100%',
                    },
                    dataLabels: {
                        value: {
                            offsetY: 30,
                            color: '#99a2ac',
                            fontSize: '2rem'
                        }
                    }
                },
            },
            colors: ['#EA5455'],
            fill: {
                type: 'gradient',
                gradient: {
                    // enabled: true,
                    shade: 'dark',
                    type: 'horizontal',
                    shadeIntensity: 0.5,
                    gradientToColors: ['#7367F0'],
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100]
                },
            },
            stroke: {
                dashArray: 10
            },
            labels: ['기여도'],
        }
    }
    this.blogAnalyticsData = {
      chartOptions: {
          plotOptions: {
              radialBar: {
                  size: 158,
                  offsetY: -30,
                  startAngle: -150,
                  endAngle: 150,
                  hollow: {
                      size: '65%',
                  },
                  track: {
                      background: "rgba(0,0,0,0)",
                      strokeWidth: '100%',
                  },
                  dataLabels: {
                      value: {
                          offsetY: 30,
                          color: '#99a2ac',
                          fontSize: '2rem'
                      }
                  }
              },
          },
          colors: ['#EA5455'],
          fill: {
              type: 'gradient',
              gradient: {
                  // enabled: true,
                  shade: 'dark',
                  type: 'horizontal',
                  shadeIntensity: 0.5,
                  gradientToColors: ['#7367F0'],
                  inverseColors: true,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
              },
          },
          stroke: {
              dashArray: 8
          },
          chart: {
              sparkline: {
              }
          },
          labels: ['기여도'],
      }
  }
      // this.$store.dispatch('task/getProjectMember',  this.$route.params.projectId).then(()=>{
      // this.photoURL = require("@/assets/images/portrait/small/" + this.getUserInfo.photo_url)
      // var memeberInfo = this.$store.getters['space/getMemberInfo'](this.$route.params.userId)

      //
      // if(!this.attends){
      //   this.$store.dispatch("insight/getAttend", this.activeWorkspace.id).then(()=>{
      //     for(var i in this.attends){
      //       var attend = this.attends[i].attend
      //       // day = this.$moment(attend.day_time).format('MM-DD')
      //       this.columnDefs.push({headerName: this.$moment(attend.day_time).format('MM-DD') , field: 'attend'+i, width: 101, cellRendererFramework: 'AttendAllStatus'})
      //       for (var j in this.insightVector){
      //         var user = this.insightVector[j]
      //         var fildName = 'attend'+i
      //         if(this.attends[i].miss.find((miss) => miss.user_id == user.user_id)){
      //           this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:3})
      //         }
      //         else if (this.attends[i].late.find((late) => late.user_id == user.user_id)){
      //           this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:2})
      //         } else{
      //           this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:1})
      //         }
      //       }
      //     }
      //   })
      // } else{
      //   for(var i in this.attends){
      //     var attend = this.attends[i].attend
      //     this.columnDefs.push({headerName: this.$moment(attend.day_time).format('MM-DD') , field: 'attend'+i, width: 101, cellRendererFramework: 'AttendAllStatus'})
      //   }
      // }

    }
  }
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }
    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}
// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }
@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
